import React, { useEffect, useState } from "react";
import {
  TextInput,
  Row,
  Column,
  FormGroup,
  TextArea,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import useAuth from "../../hooks/useAuth";
import GenericCombo from "../Combos/GenericCombo";
import ProvinceCombo from "../Combos/ProvinceCombo";
import DistrictCombo from "../Combos/DistrictCombo";
import { toast } from "react-toastify";
import http from "../../http-common";

const DataSheetForm = ({
  disabled,
  register,
  control,
  errors,
  hasBusinessCurrently,
  setHasBusinessCurrently,
  businessPlan,
  setValue,
  getValues,
  windowCode,
}) => {
  const { data: addressTypes } = useGet("/lookup/address-types");
  const [districts, setDistricts] = useState([]);
  const { isCompetitor, user } = useAuth();
  // "NUR" (Janela 1) or "NU2" (Janela 2) - must match the backend's
  // BusinessPlanService#windowFromNur prefix convention.
  const nurPrefix = windowCode === 2 ? "NU2" : "NUR";

  const handleHasBusinessCurrently = (e) => {
    setHasBusinessCurrently(e);
  };

  const getDistricts = async (provinceId) => {
    if (provinceId) {
      try {
        const response = await http.get(
          "/lookup/provinces/" + provinceId + "/districts"
        );
        setDistricts(response.data);
      } catch (error) {
        toast.error(error?.response?.data.message);
      }
    } else {
      setDistricts([]);
    }
  };

  useEffect(() => {
    if (businessPlan) {
      getDistricts(businessPlan.provinceId);
    }
  }, [businessPlan]);

  // Auto-generate NUR from phone number
  useEffect(() => {
    if (!setValue) {
      return;
    }

    if (businessPlan?.nur) {
      setValue("nur", businessPlan.nur);
    } else if (user?.username) {
      setValue("nur", `${nurPrefix}${user.username}`);
    } else {
      setValue("nur", "");
    }
  }, [businessPlan, user, setValue, nurPrefix]);

  return (
    <FormGroup legendText="1. FICHA TÉCNICA" className="section-header">
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <TextInput
              labelText="1.1	Numero Único de Referência (NUR)"
              id="nur"
              maxLength={12}
              disabled={true}
              value={
                businessPlan?.nur
                  ? businessPlan.nur
                  : user?.username
                  ? `${nurPrefix}${user.username}`
                  : ""
              }
              {...register("nur")}
            />
            <p className="field-error">{errors.nur?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <legend className="bx--label">
          1.2 Endereço de domicílio de negócio /residência
        </legend>
        <Row>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <ProvinceCombo
              id="provinceId"
              name="provinceId"
              label="Província"
              disabled={disabled}
              control={control}
              setDistricts={setDistricts}
            />
            <p className="field-error">{errors.provinceId?.message}</p>
          </Column>

          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <DistrictCombo
              id="districtId"
              name="districtId"
              label="Cidade/Distrito"
              disabled={disabled}
              items={districts}
              control={control}
            />
            <p className="field-error">{errors.districtId?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <TextInput
              id="administrativePost"
              labelText="Posto Administrativo"
              maxLength={128}
              disabled={disabled}
              {...register("administrativePost")}
            />
            <p className="field-error">{errors.administrativePost?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <TextInput
              id="locality"
              labelText="Localidade"
              maxLength={128}
              disabled={disabled}
              {...register("locality")}
            />
            <p className="field-error">{errors.locality?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={6} lg={6} className="required">
            <TextInput
              id="neighborhood"
              labelText="Bairro"
              maxLength={128}
              disabled={disabled}
              {...register("neighborhood")}
            />
            <p className="field-error">{errors.neighborhood?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <GenericCombo
              id="addressTypeCode"
              name="addressTypeCode"
              label="O endereço registado é do/a"
              disabled={disabled}
              register={register}
              items={addressTypes}
            />
            <p className="field-error">{errors.addressTypeCode?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

DataSheetForm.defaultProps = {
  disabled: false,
};

export default DataSheetForm;
